module.exports = __webpack_public_path__ + "img/icon-gift.d2e04304.svg";